module.exports = __webpack_public_path__ + "app/kiss-invoice/list-kiss-invoices-2KPtJktd.html";